import { EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, SIMPLE_CARD } from '../../../../sections/GroupCards/cardTypes';

function defaultQuestionLabelReturnStrategy(questions) {
  return [questions];
};

const questionProcessorStrategies = {
  [SIMPLE_CARD]: defaultQuestionLabelReturnStrategy,
  [MULTIPLE_CARD]: (questions) => {
    const processedQuestions = [];

    const { pergunta_principal, profileText } = questions;
    processedQuestions[0] = pergunta_principal;

    if (Array.isArray(profileText) && profileText.length) {
      processedQuestions.push(...profileText.map((crossingMeta) => crossingMeta.label));
    }
    return processedQuestions;
  },
  [SIMPLECROSS_CARD]: (questions) => {
    const processedQuestions = [];
    const { perguntas_principais } = questions || [];

    if (Array.isArray(perguntas_principais) && perguntas_principais.length) {
      perguntas_principais[0].perguntas_cruzadas.forEach((pergunta) => {
        const questionsByChart = [];
        questionsByChart[0] = perguntas_principais[0].enunciado;

        questionsByChart.push(...pergunta.alternativas.map((alternativaCruzada) => alternativaCruzada.enunciado));
        processedQuestions.push(questionsByChart);
      });
    }
    return processedQuestions;
  },
  [EVOLUTIVE_CARD]: defaultQuestionLabelReturnStrategy,
  [EVOLUTIVE_CROSS_CARD]: defaultQuestionLabelReturnStrategy
};

export function getQuestionTitlesByChartType(cardType, questions = null) {
  if (questionProcessorStrategies[cardType]) {
    const strategy = questionProcessorStrategies[cardType](questions);
    return strategy;
  }

  return [];
}
